
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/[slug]",
      function () {
        return require("private-next-pages/calculators/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/[slug]"])
      });
    }
  